<template>
  <div class="content">
    <div :class="{bg: true, empty: list.length === 0}">
      <newTopicFilter ref="interviewFilter" @getData="getFilter" :isSingle="true" :showinfo="false" :showCreate="showCreate" />
      <div class="list">
        <div class="titles">
          <span class="icon"></span>
          <span class="theme">选题名称</span>
          <span class="publisher">执行人</span>
          <span class="locate">部门</span>
          <span class="time">发布时间</span>
          <span class="status">状态</span>
          <span class="handles">操作</span>
        </div>
        <empty :mTop="30" :msg="`暂无选题库数据`" v-if="list && list.length === 0" />
        <div class="items" v-for="(i, d) in list" :key="d">
          <div class="item">
            <span class="icon">
              <i v-show="i.is_important == 1" class="top"></i>
              <i v-show="i.view_scope == 1" class="lock"></i>
            </span>
            <span class="theme" @click="handleGo(i)">
              <p class="words" :title="i.title">
                {{i.title}}
              </p>
              <img src="@assets/img/interview/new.svg" alt="new" v-if="i.is_new == 1">
            </span>
            <span class="publisher">{{i.executor_name}}</span>
            <span class="locate">{{i.depart_name}}</span>
            <span class="time">
              <span>{{i.date}}</span>
            </span>
            <span class="status">
              <span :class="{stage: true, stageComplete: i.status == 2, stageReturn: i.status == 1}">
                {{i.status_name}}
              </span>
            </span>
            <span class="handles">
              <span class="btn green" v-if="i.has_edit" @click="goEdit(i.id)">
                编辑
              </span>
              <span class="btn" v-if="i.has_del" @click="goDelete(i.id)">
                删除
              </span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import newTopicFilter from '@components/newTopicFilter'
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'allInterviews',
  components: {
    newTopicFilter, pages, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      list: [],
      searchOptions: {},
      filterOptions: {},
      showCreate: false
    }
  },
  methods: {
    goClue(i) {
      // 去创建线索页
      // const d = {
      //   id: i.id,
      //   title: i.title
      // }
      //
      // this.$router.push({
      //   name: 'creatClue',
      //   params: {
      //     interview: d
      //   }
      // })
      dc.setItv(i)

      common.jump('/creatClue', true)

      setTimeout(() => {
        dc.delItv()
      }, 0)
    },
    goCancel(i) {
      // 撤销操作
      const info = {
        iview_id: i.id
      }

      common.myFetch(apis.Itv_cancel, info)
      .then(r => {
        if (r) {
          this.$toast(r)
          this.getList()
        }
      })
    },
    getList(keyWord) {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        has_material: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.newTopicMylist, info)
      .then((data) => {
        this.list = data.list
        if(data.params && data.params.top_search){
          this.generateSearchs(data.params.top_search.option.list)
        }
        if(data.params && data.params.list_search){
          this.generateFilters(data.params.list_search)
        }

        if(data.page && data.page.row_count){
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        }
        
        this.showCreate = data.has_add_role
      })
    },
    generateFilters(data) {
      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.$refs.interviewFilter.filters = filters
    },
    generateSearchs(data) {
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getFilter(data) {
      this.filterOptions = data
      this.getList()
    },
    getSearch(d) {
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      this.$emit('filterData', data)
    },
    handleGo(i) {
      const hasEdit = !!i.has_edit
      if (hasEdit) {
        this.goEdit(i.id)
      } else {
        this.goDetail(i.id, i.status)
      }
    },
    goDetail(i, status) {
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })
      if(status == 1){
        common.jump(`/newTopicDetail?r=${i}&c=b`, true)
      }else{
        common.jump(`/newTopicDetail?r=${i}`, true)
      }
      
    },
    async goEdit(i) {
      const newWindow = window.open()
      // newWindow.location.href = `${window.location.origin}/index.html#/newTopicEdit?r=${i}`
      common.checkPageStatus(i, 6).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/newTopicEdit?r=${i}`
        } else {
          newWindow.close()
        }
      })
    },
    async goDelete(i) {
      const c = await this.$confirm('确认删除吗？')
      if (!c) return

      const info = {
        id: i
      }

      common.myFetch(apis.Tpc_delete, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    }
  },
  mounted() {
    const params = this.$route.params
    Object.assign(this.filterOptions, params)

    this.getList('noKeyWord')
    // 默认使用当天数据
    // this.$refs.interviewFilter.initDate()
  }
}
</script>

<style lang="less" scoped src="@assets/css/newTopic/myInterviews.less"></style>
